import { Collapse } from "antd";
import React from "react";

export default function FAQ({ VenuesDetails }) {

  return (
    <div className="details-section">
      <h4>{VenuesDetails?.name} frequently asked questions</h4>
      <br />
      <Collapse
        expandIconPosition="right"
        items={VenuesDetails?.faqs?.map((val, index) => ({
          key: index,
          label: <strong>{val?.question}</strong>,
          children: <p>{val?.answer}</p>,
        }))}
      />
      
    </div>
  );
}
